import { useDispatch } from "react-redux";

import { ERROR_CODE_MAP } from "@/constants/errorCode";
import { showAlertWithAction } from "@/redux/actions/alerts";

/**
 * Maps a caught error's `errorPayload.message` to a user-facing message/code
 * via ERROR_CODE_MAP, falling back to WorkflowDefault, then dispatches it as
 * an alert. Centralizes the error-code-mapping pattern repeated across
 * workflow/signup catch blocks.
 */
export function useWorkflowError() {
  const dispatch = useDispatch();

  return (error: unknown) => {
    const errorKey = (error as { errorPayload?: { message?: string } })?.errorPayload?.message;
    const { code, message } = Object.hasOwn(ERROR_CODE_MAP, errorKey ?? "")
      ? ERROR_CODE_MAP[errorKey as keyof typeof ERROR_CODE_MAP]
      : ERROR_CODE_MAP.WorkflowDefault;

    dispatch(showAlertWithAction(`${message} Code: ${code}`));
  };
}
